var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.7501 8L15.0088 9.29935L9.4076 15.0812H26V16.9188H9.4076L15.0088 22.7006L13.7501 24L6 16L13.7501 8Z","fill":"#333F48"}));
}

ArrowLeftInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
